export default "__VITE_ASSET__BgNzv_o9__"